import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { MARKED_OPTIONS, MarkdownModule } from 'ngx-markdown';

import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { NotebookModule } from '../../widgets/notebook/notebook.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { gfMarkedOptionsFactory } from '../../core/services/core.markdown-editor.service';
import { NvD3Module } from '../../widgets/nvd3';
import { ProjectModule } from '../../core/modules/project/project.module';
import { TrackerLibModule } from './lib/tracker.lib.module';
import { TrackerAdminModule } from './trackerAdmin/tracker.admin.module';
import { TRACKER_STATES } from './tracker.routes.config';

import { DiffAggregateService } from '../scm/services/scm.diff.service';
import { ScmService } from '../scm/services/scm.service';
import { FileTypeService } from './services/file-type.service';
import { TrackeritemEditModalComponent } from './edit/trackerItemEditModal/trackeritem.edit.modal.component';
import { TrackerItemAutoCloseToggleComponent } from './edit/lib/autoCloseToggle/trackeritem.auto.close.toggle.component';
import { LockStatusComponent } from './edit/lib/lockStatus/trackeritem.lock-status.component';
import { TrackeritemDeleteButtonComponent } from './edit/lib/deleteButton/trackeritem.delete.button.component';
import { TrackeritemDeleteModalComponent } from './edit/lib/deleteButton/trackeritem.delete.modal.component';
import { FieldListComponent } from './edit/field-list/trackeritem.field-list.component';
import { CommitsTabComponent } from './edit/commits-tab/trackeritem.commits-tab.component';
import { NotebookTabComponent } from './edit/notebook-tab/trackeritem.notebook-tab.component';
import { TrackeritemEditTimelineComponent } from './edit/timeline/trackeritem.timeline.component';
import { TrackeritemTimelineHelper } from './edit/timeline/trackeritem.timeline.helper';
import { RelatedTabComponent } from './edit/related-tab/trackeritem.related-tab.component';
import { BreakdownTabComponent } from './edit/breakdown-tab/trackeritem.breakdown-tab.component';
import { BreakdownAddComponent } from './edit/breakdown-tab/trackeritem.breakdown-add.component';
import { BreakdownListComponent } from './edit/breakdown-tab/trackeritem.breakdown-list.component';
import { TrackeritemAddModalComponent } from './trackerItemAdd/trackerItemAddModal/trackeritem.add.modal.component';
import { MergeTabComponent } from './edit/merge-tab/trackeritem.merge-tab.component';
import { TrackeritemQueueToggleComponent } from './edit/lib/queueToggle/trackeritem.queue.toggle.component';
import { TrackeritemMonitorToggleComponent } from './edit/lib/monitorToggle/trackeritem.monitor.toggle.component';
import { TiEditHeaderComponent } from './edit/lib/edit-header/trackeritem.edit-header.component';
import { DependencyHeaderComponent } from './edit/lib/dependencyHeader/dependency.header.directive';
import { BreakdownHeaderComponent } from './edit/lib/breakdownHeader/breakdown.header.component';
import { TiPromotionBarComponent } from './edit/lib/promotion-bar/trackeritem.promotion-bar.component';
import { TrackeritemEditToolbarComponent } from './edit/lib/toolbar/trackeritem.toolbar.component';
import { SummaryBarComponent } from './edit/lib/summary-bar/trackeritem.summary-bar.component';
import { TrackeritemEditComponent } from './edit/ti-edit.main.component';
import { TrackerItemAddToolbarComponent } from'./trackerItemAdd/trackerItemAddToolbar/trackeritem.add.toolbar.component';
import { TrackerItemAddComponent } from './trackerItemAdd/trackeritem.add.component';
import { TrackerItemBrowseScreenComponent } from './trackerItemBrowse/trackeritem.browse.screen.component';
import { TiApprovalPanelComponent } from './edit/lib/approvalPanel/ti-approval-panel.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      TrackerLibModule,
      TrackerAdminModule,
      CoreWidgetsModule,
      NotebookModule,
      CoreFiltersModule,
      NvD3Module,
      ProjectModule,
      MarkdownModule.forRoot({
        markedOptions: {
          provide: MARKED_OPTIONS,
          useFactory: gfMarkedOptionsFactory
        }
      }),
      UIRouterModule.forChild({ states: TRACKER_STATES })
    ],
    exports: [
    ],
    declarations: [
      TrackerItemAutoCloseToggleComponent,
      LockStatusComponent,
      TrackeritemEditModalComponent,
      TrackeritemDeleteButtonComponent,
      TrackeritemDeleteModalComponent,
      FieldListComponent,
      CommitsTabComponent,
      NotebookTabComponent,
      TrackeritemEditTimelineComponent,
      RelatedTabComponent,
      BreakdownTabComponent,
      BreakdownAddComponent,
      BreakdownListComponent,
      TrackeritemAddModalComponent,
      MergeTabComponent,
      TrackeritemQueueToggleComponent,
      TrackeritemMonitorToggleComponent,
      TiEditHeaderComponent,
      DependencyHeaderComponent,
      BreakdownHeaderComponent,
      TiPromotionBarComponent,
      TrackeritemEditToolbarComponent,
      SummaryBarComponent,
      TrackeritemEditComponent,
      TrackerItemAddToolbarComponent,
      TrackerItemAddComponent,
      TrackerItemBrowseScreenComponent,
      TiApprovalPanelComponent
	  ],
    providers: [
      DiffAggregateService,
      ScmService,
      TrackeritemTimelineHelper,
      FileTypeService
    ]
})
export class TrackerModule {
    constructor() { }
}
